import { Injectable } from '@angular/core';
import { IFilterListService } from './ifilter-list.service';
import { map } from 'rxjs';
import { Selectable } from '../models/types/selectable.type';
import { GetQuery } from '../../models/shared/enums/get-query.enum';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { WrapperResultGraphQL } from '../../models/shared/types/wrapper-result-graphql.type';
import { PageInfo } from '../../models/shared/types/page-info.type';
import { Purpose } from '../../models/company/purpose.type';

@Injectable({
  providedIn: 'root'
})
export class PurposeFilterService extends IFilterListService<Purpose> {
  pageInfo: PageInfo = { hasPreviusPage: false, hasNextPage: false, startCursor: null, endCursor: null };

  search(searchText: string, variables): void {
    if (searchText) this.pageInfo = { ...this.pageInfo, endCursor: null, startCursor: null };

    this.graphQlService.getData<Purpose>(GetQuery.GET_PURPOSES_NO_IDS, { search: searchText, companyId: this.appService.companyId, first: variables.first, after: this.pageInfo.endCursor })
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(res => res['data']['purposes'])
      )
      .subscribe({
        next: (res: WrapperResultGraphQL<Purpose>) => {
          let datasource: Array<Selectable<Purpose>> = [];
          if (this.pageInfo.endCursor) {
            const actualValue = this.datasource.getValue();
            datasource = [...actualValue, ...res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }))];
          } else {
            datasource = res.nodes.map(el => ({ ...el, displayId: el.id!, displayName: el.name, disabled: false, selected: false }));
          }

          this.pageInfo = res.pageInfo;
          this.datasource.next(datasource);
        }
      })
  }
}
